import { memo, useEffect } from "react"
import { BrowserRouter, Routes, Route, useLocation, useMatches } from "react-router";
import { Button, Center, Container, Stack, Portal, Text, HStack, VStack } from "@chakra-ui/react"


import Home from "@/pages/home"
import Product from "@/pages/product"
import Cart from "@/pages/cart"
import Checkout from "@/pages/checkout"
import Invoice from "@/pages/invoice"
import Thank from "@/pages/thank"
import Order from "@/pages/order"
import OrderPay from "@/pages/order-pay"
import OrderList from "@/pages/order-list"

import Policy from "@/pages/policy";

import Profile from "@/pages/profile"
import ProfileEdit from "@/pages/profile/edit"
import BlogLanding from "@/pages/blog"
import BlogListPage from "@/pages/blog/list"
import Point from "@/pages/point"
import Debt from "@/pages/debt"
import Ctv from "@/pages/ctv"
import CtvProduct from "@/pages/ctv/ProductPage"
import CtvHistory from "@/pages/ctv/History"
import BankInfo from "@/pages/profile/bank"
import ProductCollectionPage from "@/pages/product_collection"
import ChatPage from "@/pages/chat"
import GalleryPage from "@/pages/gallery"
const ShopRouter = () => {


    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogLanding />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/profile/edit" element={<ProfileEdit />} />
            <Route path="/profile/bank" element={<BankInfo />} />
            <Route path="/point" element={<Point />} />
            <Route path="/debt" element={<Debt />} />

            <Route path="/cart" element={<Cart />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/thank/:id" element={<Thank />} />
            <Route path="/order/:id" element={<Order />} />
            <Route path="/order-pay/:id" element={<OrderPay />} />
            <Route path="/order-list" element={<OrderList />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/product-collection/:id" element={<ProductCollectionPage />} />
            <Route path="/collection/:url_handle" element={<ProductCollectionPage />} />
            <Route path="/ctv" element={<Ctv />} />
            <Route path="/ctv/product" element={<CtvProduct />} />
            <Route path="/ctv/history" element={<CtvHistory />} />
        </Routes>
    )
}

export default memo(ShopRouter)